
import React from "react";
import { ProfessionData } from "@/data/professionSolutions";
import * as LucideIcons from "lucide-react";

interface ProfessionHeroProps {
  profession: ProfessionData;
}

const ProfessionHero: React.FC<ProfessionHeroProps> = ({ profession }) => {
  const { title, description, heroImage, icon } = profession;
  
  // Get the Lucide icon component
  const IconComponent = (LucideIcons as any)[icon] || LucideIcons.Recycle;
  
  return (
    <div className="relative">
      <div
        className="bg-cover bg-center h-[300px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('${heroImage || '/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png'}')`
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-3xl text-white">
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3">
                <IconComponent className="h-8 w-8 text-white" />
              </div>
              <h1 className="text-3xl md:text-4xl font-heading font-bold">
                {title}
              </h1>
            </div>
            <p className="text-lg mb-6">
              {description}
            </p>
          </div>
        </div>
      </div>

      {/* Vague décorative */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg 
          className="relative block w-full h-[50px]" 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 100" 
          preserveAspectRatio="none"
        >
          <path 
            fill="#ffffff" 
            fillOpacity="1" 
            d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default ProfessionHero;
